import React from "react"

import styled, { css } from "styled-components"
import { hideVisually } from "polished"

import Logo from "../images/tryhard-japan-white.inline.svg"
import Logo2 from "../images/tryhard-japan-white-new.svg"
import TryhardJapanLogo from "../images/tryhard-japan-white-new2.png";

export default ({ isHome }) => {
  const LogoContainer = isHome ? LogoContainerH1 : LogoContainerH2

  return (
    <Header>
      <LogoContainer>
        <span>TryHard JAPAN</span>
        {/* <Logo /> */}
        <img src={TryhardJapanLogo} alt="Tryhard Japan Logo" style={{ position: 'absolute', left: '0px', top: '0px', width:'200%' }}  />
      </LogoContainer>
      <TryHardGroup>TryHard JAPAN GROUP</TryHardGroup>
    </Header>
  )
}

const Header = styled.header`
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  z-index: 50;
`

const logoContainerStyles = () => css`
  position: absolute;
  top: 2rem;
  left: 2rem;

  width: calc((100vw - ${({ theme }) => `${theme.maxWidth}px`}) / 2 - 3rem);
  max-width: 100px;
  min-width: 50px;
  margin: 0;

  &::before {
    content: "";
    display: block;
    width: 100%;
    padding-top: 134%;
  }

  svg {
    position: absolute;
    left: 0;
    top: 0;
  }

  span {
    ${hideVisually()};
  }

  @media (max-width: 374px) {
    min-width: 40px;
  }
`

const LogoContainerH2 = styled.h2`
  ${logoContainerStyles()}
`
const LogoContainerH1 = styled.h1`
  ${logoContainerStyles()}
`

const TryHardGroup = styled.p`
  position: absolute;
  left: 50%;
  top: 1.5rem;
  transform: translateX(-50%);

  margin: 0;
  text-align: center;

  font-family: futura-pt, sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 2rem;

  color: ${({ theme }) => theme.colors.accent};

  text-shadow: 0 0 1rem rgba(0, 0, 0, 0.75);

  @media (max-width: 500px) {
    font-size: 1.5rem;
  }

  @media (max-width: 374px) {
    font-size: 1.25rem;
  }
`
